module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Screen_16"],"path":[{"$":{"d":"M15,12V1H1V12H7v2H4v1h8V14H9V12ZM3,3H13v7H3Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Screen_16.svg
// module id = 3lYk
// module chunks = 1